import * as React from 'react';

const ParadexIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 726 726"
    fill="#7FABEC"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M646.77 96.22C637.854 83.4272 627.566 71.6473 616.09 61.09C575.04 23.31 518.44 0 455.81 0H44L94.24 87.44C99.6866 96.9185 107.537 104.793 116.998 110.269C126.46 115.745 137.198 118.629 148.13 118.63H268.7L455.82 118.44C482.93 118.44 507.41 128.54 525.08 144.88C542.85 161.15 553.81 183.68 553.81 208.55C553.81 258.38 509.96 298.74 455.82 298.74L396.5 298.55H121.23L171.47 385.99C176.917 395.468 184.767 403.343 194.228 408.819C203.69 414.295 214.428 417.179 225.36 417.18H249.77C260.22 417.18 268.69 425.65 268.69 436.1V725.78L360.18 655.14C369.301 648.097 376.685 639.058 381.766 628.715C386.847 618.373 389.489 607.003 389.49 595.48V436.1C389.49 425.65 397.96 417.18 408.41 417.18H455.82C545.9 417.18 623.65 368.83 660.2 298.74C674.47 271.44 682.46 240.86 682.46 208.55C682.46 167.17 669.37 128.68 646.77 96.22Z"
    />
  </svg>
);

export default ParadexIcon;
